import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function reportCleaned(items, marks) {
  axios.post(`${API}/stats/report`, { items, marks }).catch(() => {});
}
